<template>
	<div 
		:style="style"
		@click="click" 
		class="my-input" 
		@mouseleave="mouseleave"
		@mouseenter="mouseenter">
		<input 
			:type="type" 
			@blur="blur" 
			@focus="focus" 
			@input="input"
			v-model="myValue" 
			:style="inputStyle"
			:disabled="disabled"
			@keyup.enter="enter"
			:placeholder="placeholder"
			class="my-input-inner">
		<my-icon 
			size="20px" 
			icon="close"
			:color="color"
			@mousedown="clear" 
			:style="clearStyle"/>
	</div>
</template>

<script>
	import myIcon from './my-icon.vue'
	export default {
		name: 'my-input',
		props: {
			value: null,
			disabled: {
				type: Boolean,
				default: false
			},
			type: {
				type: String,
				default: 'text'
			},
			color: {
				type: String,
				default: '#FFFFFF'
			},
			borderColor: {
				type: String,
				default: '#FFFFFF'
			},
			placeholder: {
				type: String,
				default: ''
			}
		},
		data() {
			return {
				myValue: this.value,
				showColor: false,
				showClear: false
			}
		},
		watch: {
			value: {
				handler(newValue) {
					this.myValue = newValue;
				},
				immediate: true
			}
		},
		methods: {
			blur() {
				this.showColor = false;
				this.showClear = false;
				this.$emit('blur', this.myValue);
				// console.log('输入框失去焦点事件', event)
				if (navigator.userAgent.toLocaleLowerCase().includes('iphone')) {
					// ui.showToast('输入框失去焦点事件');
					window.scroll(0, 0);
				}
				// this.$message(navigator.userAgent.toLocaleLowerCase());
			},
			focus() {
				this.mouseenter();
				this.showColor = true;
				this.$emit('focus', this.myValue);
			},
			enter() {
				this.$emit('enter', this.myValue);
			},
			clear() {
				this.myValue = '';
				this.showClear = false;
				this.$emit('clear', '');
				this.$emit('input', '');
			},
			input() {
				this.mouseenter();
				this.$emit('input', this.myValue);
				// (this.myValue === '') && this.clear();	// 手动清空不触发
			},
			click(event) {
				this.$emit('click', event);
			},
			mouseleave() {
				if ((this.disabled === false) && (this.showColor === false)) {
					this.showClear = false;
				}
			},
			mouseenter() {
				if ((this.disabled === false) && this.myValue) {
					this.showClear = true;
				}
			}
		},
		computed: {
			style() {
				let style = this.disabled ? 'cursor: not-allowed;' : '';
				if (this.showColor && this.borderColor) {
					style += `border-color: ${this.borderColor}!important;`;
				}
				return style;
			},
			inputStyle() {
				let style = this.disabled ? 'cursor: not-allowed;' : '';
				style += `color: ${this.color}!important;`;
				return style;
			},
			clearStyle() {
				return `visibility: ${this.showClear ? 'visible' : 'hidden'}`;
			}
		},
		components: {
			'my-icon': myIcon
		}
	}
</script>

<style scoped lang="less">
	.my-input{
		padding: 7px;
		display: flex;
		font-size: 1.6rem;
		border-radius: 2px;
		align-items: center;
		box-sizing: border-box;
		border: 1px solid #DCDFE6;
		background-color: transparent;
		.my-input-inner{
			margin: 0;
			padding: 0;
			width: 100%;
			height: 100%;
			border: none;
			outline: none;
			margin-right: 7px;
			font-size: inherit;
			border-radius: inherit;
			background-color: inherit;
		}
	}
</style>
